import { createI18n } from 'vue-i18n'
import zhCN from './zh-CN.json'
import en from './en.json'
import fr from './fr.json'
import de from './de.json'
import it from './it.json'
import es from './es.json'
import tr from './tr.json'
import ar from './ar.json'

const i18n = createI18n({
  legacy: false,
  locale: localStorage.getItem('xiongsu-language') || 'en',
  fallbackLocale: 'en',
  messages: { 'zh-CN': zhCN, en, fr, de, it, es, tr, ar }
})

export default i18n
